import React, { useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import InputMask from 'react-input-mask';
import cn from 'classnames';
import styles from '../styles.scss';
import { Button } from '../../Button';
import { sendPhone, Types } from '../common';
import { trackGA, gaEvent } from 'services/ga';
import debounce from 'lodash.debounce';

export const Phone = ({ goToPhoneStep, showErrorModal, goToCodeStep, type, setType, setPhone, showRegistration, phone }) => {
  const refInput = useRef();
  const { error: phoneError, isLoading: isLoadingPhone, refetch: postPhone } = useQuery(['code', phone, type],
    () => sendPhone({ phone, type }), {
      onSuccess: () => {
        goToCodeStep();
        setPhone(phone);
      },
      onError: (error) => {
        if (error === 'ERROR_SEND_CALL') {
          showErrorModal();
          return;
        }

        if (error === 'INTERNAL_ERROR') {
          showErrorModal();
          return;
        }

        if (error === 'USER_NOT_FOUND') {
          goToPhoneStep();
          showRegistration();
        }
      }
    });

  useEffect(() => {
    if (!refInput.current) {
      return;
    }

    const handleEnter = (e) => {
      if (e.key !== 'Enter') {
        return;
      }

      if (isLoadingPhone) {
        return;
      }

      if (phone.length !== 18) {
        return;
      }

      postPhone();
    };

    document.addEventListener('keypress', handleEnter);

    return () => {
      document.removeEventListener('keypress', handleEnter);
    };
  }, [refInput.current, phone, isLoadingPhone]);

  const debouncedEnterPhoneEvent = debounce(() => {
    trackGA(gaEvent.loginPhoneInput());
  }, 3000);

  useEffect(() => {
    if (phone.length >= 7) {
      debouncedEnterPhoneEvent();
    }

    return () => {
      debouncedEnterPhoneEvent.cancel();
    };
  }, [phone]);

  const { t } = useTranslation();
  const toggleType = () => {
    setType(prev => prev === Types.Call ? Types.Sms : Types.Call);
    trackGA(gaEvent.loginButtonsClick({ eventLabel: type === Types.Call ? 'voiti_po_sms' : 'voiti_po_zvonku' }));
  };
  const getError = (error) => {
    if (!error) {
      return null;
    }

    if (error === 'USER_NOT_FOUND') {
      return t('components.login.formNumber.userNotFound');
    }

    return t('components.login.formNumber.serverError');
  };

  const error = getError(phoneError);

  const handleInputChange = ({ target }) => {
    const { value } = target;
    setPhone(value);
  };

  return (
    <React.Fragment>
      <InputMask
        ref={refInput}
        type="tel"
        className={styles.PhoneInput}
        data-key="phoneNumber"
        value={phone}
        placeholder="+7 (XXX) XXX XX-XX"
        onChange={handleInputChange}
        mask="+7 (999) 999 99-99"
        maskChar=""
      />

      <div
        className={cn(styles.LoginFormHint, {
          [styles.LoginFormHintError]: error
        })}
        dangerouslySetInnerHTML={{ __html: error || t(`containers.logIn.hint-phone-${type}`) }}
      />
      <div className={styles.LoginFormButtons}>
        <Button
          isLoading={isLoadingPhone}
          isDisabled={phone.length !== 18}
          onClick={() => {
            postPhone();
            trackGA(gaEvent.loginButtonsClick({ eventLabel: 'prodolzhit' }));
          }}
          isPrimary
        >
          {t('containers.logIn.buttons.continue')}
        </Button>

        <Button isDisabled={isLoadingPhone} onClick={toggleType}>
          {type === Types.Call ? t('containers.logIn.buttons.bySms') : t('containers.logIn.buttons.byCall')}
        </Button>

      </div>
      <div className={styles.LoginFormRegistration}>
        <span
          onClick={() => {
            showRegistration();
            trackGA(gaEvent.loginButtonsClick({ eventLabel: 'zaregistriruites' }));
          }}
        >
          {t('containers.logIn.registration')}
        </span>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Login/Form/Phone/index.js